<template>
  <div
    id="login-view"
    class="form-container position-absolute top-50 start-50 w-20 translate-middle"
  >
    <!-- ------------ -->
    <!--    header    -->
    <!-- ------------ -->
    <div class="outer-area">
      <div class="auth-box text-center">
        <img
          class="mt-4"
          :src="bbLogo"
          alt="logo"
        />
        <p class="fw-lighter mt-4 mb-5 bb-app-heading">BATTLEBOARD</p>
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent="login">
          <div class="form-group">
            <!-- ------------ -->
            <!--     email    -->
            <!-- ------------ -->
            <div class="form-floating mb-3">
              <input
                v-model="email"
                onkeyup="this.value = this.value.toLowerCase();"
                type="email"
                name="email"
                id="floatingEmail"
                placeholder="email"
                class="form-control"
                style="font-size: 2vh !important"
                autocomplete="username"
                required
              />
              <label
                class="bb-float-label"
                for="floatingEmail"
                >Email</label
              >
            </div>
            <!-- ------------ -->
            <!--   password   -->
            <!-- ------------ -->
            <div class="form-group">
              <div class="form-floating password mb-3">
                <input
                  v-model="password"
                  type="password"
                  name="password"
                  class="form-control"
                  placeholder="password"
                  style="font-size: 2vh !important"
                  id="password"
                  autocomplete="current-password"
                  required
                />
                <label
                  class="bb-float-label"
                  for="password"
                  >Password</label
                >
                <!-- ---------------------- -->
                <!--   show/hide password   -->
                <!-- ---------------------- -->
                <div class="input-group-addon">
                  <i
                    class="bi bi-eye-slash"
                    id="togglePassword"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <!-- ------------ -->
          <!--    errors    -->
          <!-- ------------ -->
          <div
            v-for="err in errors"
            :key="err.id"
            class="bb-error-wrap mt-2"
          >
            <div>{{ err }}</div>
          </div>
          <!-- ------------ -->
          <!--    message   -->
          <!-- ------------ -->
          <div
            v-if="authMessageText"
            class="bb-message mt-2"
          >
            <p
              class="mb-0"
              style="white-space: pre-line"
            >
              {{ authMessageText }}
            </p>
            <router-link
              v-if="authMessageLink"
              class="bb-link"
              :to="authMessageLink.to"
              >{{ authMessageLink.label }}</router-link
            >
          </div>
          <!-- ------------ -->
          <!--    submit    -->
          <!-- ------------ -->
          <div class="d-grid gap-3">
            <button
              type="submit"
              :disabled="!email || !password"
              class="btn btn-lg btn-primary mt-3 mb-3"
            >
              Login
            </button>
          </div>
        </form>
        <!-- ------------------ -->
        <!--     register       -->
        <!-- ------------------ -->
        <div class="bb-vert-text-divider mt-3">
          <!-- ------------------ -->
          <!--   forgotten password   -->
          <!-- ------------------ -->
          <router-link
            class="bb-link"
            :to="{ name: 'forgottenPasswordView' }"
            >Forgotten Password</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import bbLogo from '/bbLogo32Blue.png'

//----------------------
// scripts
//----------------------
export default {
  name: 'loginView',
  data() {
    return {
      bbLogo,
      email: '',
      password: '',
      errors: [],
    }
  },
  //----------------------
  // computed values
  //----------------------
  computed: {
    ...mapGetters('auth', {
      isAuthenticated: 'isAuthenticated',
      getMessage: 'getMessage',
    }),
    authMessageText() {
      if (!this.getMessage) {
        return ''
      }

      if (typeof this.getMessage === 'string') {
        return this.getMessage
      }

      return this.getMessage.text || ''
    },
    authMessageLink() {
      if (!this.getMessage || typeof this.getMessage === 'string') {
        return null
      }

      return this.getMessage.link || null
    },
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapActions('auth', {
      userLogin: 'userLogin',
    }),
    ...mapMutations('auth', {
      destroyMessage: 'destroyMessage',
      setCurrentView: 'setCurrentView',
      setMessage: 'setMessage',
    }),
    setView(view) {
      this.setCurrentView(view)
    },
    //========================================================
    // force initial focus
    //---------------------
    forceInitialFocus() {
      this.editingMode = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    //========================================================
    // login
    //-------
    async login() {
      //
      this.errors = []
      const payload = {
        email: this.email,
        password: this.password,
      }
      //-------------------
      // clear any message
      //-------------------
      this.destroyMessage()
      //----------
      // api call
      //----------
      await this.userLogin(payload)
        //-------------
        // where error
        //-------------
        .catch((err) => {
          let error = window.bbErrorMsg(err)
          if (error == 'unverified') {
            const message = {
              text: 'Verify your account via the email sent to you in order to login.\n\nIf you have not received this email, use the link below.',
              link: {
                to: '/resendemail',
                label: 'Resend verification email',
              },
            }
            this.setMessage(message)
          } else {
            this.errors.push(error)
          }
        })
      //----------------------
      // where successful
      //----------------------
      if (this.isAuthenticated) {
        this.$router.push('/')
      }
    },
  },
  //========================================
  // mounted
  //---------
  mounted() {
    this.setView('partial')
    document.body.className = 'bb-bg-partial'

    const redirectedEmail = String(this.$route.query.email || '')
      .trim()
      .toLowerCase()
    if (redirectedEmail) {
      this.email = redirectedEmail
    }

    const togglePassword = document.querySelector('#togglePassword')
    const password = document.querySelector('#password')

    togglePassword.addEventListener('click', () => {
      const type =
        password.getAttribute('type') === 'password' ? 'text' : 'password'
      password.setAttribute('type', type)
      togglePassword.classList.toggle('bi-eye')
    })
  },

  unmounted() {
    document.body.className = 'bb-bg-full'
  },
}
</script>
